export default __webpack_public_path__ + "static/media/pdf_logo.ba39f3a3.png";